import { gql } from '@apollo/client';

import {
  BILLING_SUBSCRIPTION_DETAILS_FRAGMENT,
  BILLING_SUBSCRIPTION_OPTION_DETAILS_FRAGMENT,
} from './CompanyBillingDetailedQuery.graphql';

export const BILLING_SUBSCRIPTION_PLAN_UPDATE_MUTATION = gql`
  mutation BillingSubscriptionPlanUpdate(
    $input: BillingSubscriptionPlanUpdateInput!
  ) {
    billingSubscriptionPlanUpdate(input: $input) {
      billingSubscription {
        ...BillingSubscriptionDetails
        subscriptionOption {
          ...BillingSubscriptionOptionDetails
        }
      }
      updatedStatus {
        action
        planTierFrom
        planTierTo
        cycleFrom
        cycleTo
      }
      startedTrial
      errors {
        message
        path
        error
      }
    }
  }

  ${BILLING_SUBSCRIPTION_DETAILS_FRAGMENT}
  ${BILLING_SUBSCRIPTION_OPTION_DETAILS_FRAGMENT}
`;
